import React, { Component } from 'react';
import '../../App.scss';
import 'antd/dist/antd.css';
import './AdminProfileLayout.css';
import { Layout, Breadcrumb, Button, Switch } from 'antd';
import { CloseSquareOutlined, MenuFoldOutlined, MenuUnfoldOutlined, ExperimentOutlined } from '@ant-design/icons';
import firebase from 'firebase/app';
import {Redirect} from 'react-router-dom';

import { isAdminTestModeOn, setAdminTestModeOn } from '../../utils/testMode';
import { TEST_MODE_COLOR, TEST_PILL_RED } from '../../components/client/TestModeBanner';
import StrikeFooter from '../../components/StrikeFooter';
import StrikeAdminModel from '../../models/StrikeAdminModel';
import { AdminMenu } from '../../components/admin/AdminMenu'
import CenteredSpinner from '../../components/CenteredSpinner';

const { Header, Content, Sider } = Layout;
const SIDER_STATE_KEY = 'strikepay_admin_sider_state';

const SIDER_STATES = ['expanded', 'collapsed', 'hidden'];

function getStoredSiderState() {
    try {
        if (typeof window === 'undefined' || !window.localStorage) return 'expanded';
        const stored = window.localStorage.getItem(SIDER_STATE_KEY);
        if (stored === null) return 'expanded';
        const parsed = JSON.parse(stored);
        return SIDER_STATES.includes(parsed) ? parsed : 'expanded';
    } catch {
        return 'expanded';
    }
}

function setStoredSiderState(state) {
    try {
        if (typeof window !== 'undefined' && window.localStorage) {
            window.localStorage.setItem(SIDER_STATE_KEY, JSON.stringify(state));
        }
    } catch {
        // ignore
    }
}

function cycleSiderState(current) {
    const idx = SIDER_STATES.indexOf(current);
    return SIDER_STATES[(idx + 1) % SIDER_STATES.length];
}

export default class AdminLayout extends Component {

    constructor(props) {
        super(props);
        const clientId = this.props.match.params.clientId;
        this.model = props.adminModel || new StrikeAdminModel({viewModel: this});
        if (props.adminModel) props.adminModel.viewModel = this;
        this.state = {
            //isClientProfileDisplayScreen flag ensures that the extra client type check is done only for team client profile display screen
            isClientProfileDisplayScreen: props.match && (props.match.path === '/admin/clients/:clientId'),
            clientId: clientId,
            isLoggedInUserAdmin: false,
            checkingAdminUser: true,
            checkingClientType: props.match && (props.match.path === '/admin/clients/:clientId'),
            siderState: getStoredSiderState(),
        };
    }

    setSiderState = (state) => {
        this.setState({ siderState: state });
        setStoredSiderState(state);
    };

    cycleSider = () => {
        const next = cycleSiderState(this.state.siderState);
        this.setSiderState(next);
    };

    async logOut() {
        await firebase.auth().signOut();
    }

    async componentDidMount() {
        const stored = getStoredSiderState();
        if (stored !== this.state.siderState) {
            this.setState({ siderState: stored });
        }
        await this.model.waitForAdminCheck();
        // DO NOT REDIRECT WHEN CLIENT IS A TEAM CLIENT
        this.setState({checkingClientType: false});
    }

    componentWillUnmount() {
        if (this.model) this.model.stop();
    }

    setUserRoleInState(isUserAdmin) {
        this.setState({isLoggedInUserAdmin: isUserAdmin});
        this.setState({checkingAdminUser: false});
    }


    render() {
        const crumbs = this.props.crumbs || ['Admin', 'Dashboard'];

        if (this.state.checkingAdminUser || this.state.checkingClientType) {
            return <CenteredSpinner loading={this.state.checkingAdminUser}/>
        }

        if (!this.state.isLoggedInUserAdmin) {
            return <Redirect to="/"/>
        }
        return (
            <Layout className="layout">
                <Sider
                    collapsible
                    collapsed={this.state.siderState !== 'expanded'}
                    collapsedWidth={this.state.siderState === 'hidden' ? 0 : 80}
                    trigger={null}
                    style={{ backgroundColor: 'white' }}
                    breakpoint="lg"
                >
                    <AdminMenu
                        collapsed={this.state.siderState !== 'expanded'}
                        siderState={this.state.siderState}
                        onToggleCollapse={this.cycleSider}
                    />
                </Sider>
                <Layout>
                    <Header className="top" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: isAdminTestModeOn() ? TEST_MODE_COLOR : '#000098bb'}}>
                        <Button
                            type="text"
                            icon={
                                this.state.siderState === 'expanded'
                                    ? <MenuFoldOutlined />
                                    : this.state.siderState === 'collapsed'
                                        ? <CloseSquareOutlined />
                                        : <MenuUnfoldOutlined />
                            }
                            style={{ color: '#fff', fontSize: 18 }}
                            onClick={this.cycleSider}
                            aria-label={
                                this.state.siderState === 'expanded'
                                    ? 'Shrink menu'
                                    : this.state.siderState === 'collapsed'
                                        ? 'Hide menu'
                                        : 'Expand menu'
                            }
                        />
                        <span style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#fff' }}>
                            {/* Admin-global Test Mode: flips the DEFAULT world for the
                                whole admin browser — aggregates and every client not
                                explicitly chosen. Reload rebuilds every screen's models
                                in the new world. */}
                            {isAdminTestModeOn() && (
                                <span style={{ fontWeight: 700, letterSpacing: '0.06em' }}>
                                    <ExperimentOutlined /> TEST MODE
                                </span>
                            )}
                            <Switch
                                checked={isAdminTestModeOn()}
                                checkedChildren="TEST"
                                unCheckedChildren="LIVE"
                                style={isAdminTestModeOn() ? { backgroundColor: TEST_PILL_RED } : undefined}
                                onChange={(next) => { setAdminTestModeOn(next); window.location.reload(); }}
                                data-testid="admin-test-mode-switch"
                            />
                            <Button style={{color: '#fff', cursor: 'select'}} className="log-out" type="text"
                                    onClick={this.logOut}>Log out</Button>
                        </span>
                    </Header>
                    <Content style={{padding: '0 0px', minWidth: '300px', width: '100%'}}>
                        <div className="site-layout-content">
                            {this.props.children}
                        </div>
                    </Content>
                    <StrikeFooter locStrings={this.props.locStrings}/>
                </Layout>
            </Layout>
        );
    }
}
